// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-list-item-icon {
  color: rgba(0, 0, 0, 0.54);
}

.mdc-list-item--with-leading-icon .mdc-list-item__start {
  margin-left: 16px !important;
  margin-right: 16px !important;
}

mat-list-item.mat-list-item-interactive:not(.item-selected):hover {
  background: whitesmoke;
  cursor: pointer;
}

.item-selected {
  background: #e8e2e2;
  cursor: pointer;
}

.edit-options {
  display: inline-flex;
  background: white;
  padding: 10px;
  border-radius: 10px;
}

.file-div {
  background: #dfd8d8;
  padding: 25px 10px;
}

.file-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.drag-element {
  text-align: center;
  cursor: grab;
}
.drag-element img {
  max-width: 100%;
  max-height: 100%;
}
.drag-element video {
  max-width: 100%;
  max-height: 100%;
}
.drag-element:active {
  cursor: grabbing;
}

iframe body {
  position: absolute;
  overflow: scroll;
}
iframe html {
  overflow: auto;
}
iframe ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
iframe ::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(132, 128, 128, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/app/power-search/mms-search-results/mms-search-results.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;AACJ;;AAEA;EACI,4BAAA;EACA,6BAAA;AACJ;;AAEA;EACI,sBAAA;EACA,eAAA;AACJ;;AAEA;EACI,mBAAA;EACA,eAAA;AACJ;;AAEA;EACI,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,YAAA;AACJ;AACI;EACI,eAAA;EACA,gBAAA;AACR;AAEI;EACI,eAAA;EACA,gBAAA;AAAR;AAGI;EACI,gBAAA;AADR;;AAMI;EACI,kBAAA;EACA,gBAAA;AAHR;AAKI;EACI,cAAA;AAHR;AAKI;EACI,UAAA;EACA,WAAA;AAHR;AAKI;EACI,kBAAA;EACA,0CAAA;AAHR","sourcesContent":[".mat-mdc-list-item-icon {\n    color: rgba(0, 0, 0, 0.54);\n}\n\n.mdc-list-item--with-leading-icon .mdc-list-item__start {\n    margin-left: 16px !important;\n    margin-right: 16px !important;\n}\n\nmat-list-item.mat-list-item-interactive:not(.item-selected):hover {\n    background: whitesmoke;\n    cursor: pointer;\n}\n\n.item-selected {\n    background: #e8e2e2;\n    cursor: pointer;\n}\n\n.edit-options {\n    display:inline-flex;\n    background: white;\n    padding:10px;\n    border-radius:10px;\n}\n\n.file-div {\n    background: #dfd8d8;\n    padding: 25px 10px;\n}\n\n.file-container {\n    display: flex; \n    justify-content: center; \n    align-items: center; \n    width: 100%; \n    height: 100%; \n    overflow: hidden;\n}\n\n.drag-element {\n    text-align: center;\n    cursor: grab;\n\n    img {\n        max-width: 100%;\n        max-height: 100%;\n    }\n\n    video {\n        max-width: 100%;\n        max-height: 100%;\n    }\n\n    &:active {\n        cursor:grabbing;\n    }\n}\n\niframe {\n    body   {\n        position: absolute;\n        overflow: scroll;\n    }\n    html {\n        overflow: auto;\n    }\n    ::-webkit-scrollbar {\n        width: 6px;\n        height: 6px;\n    }\n    ::-webkit-scrollbar-thumb {\n        border-radius: 4px;\n        background-color: rgba(132, 128, 128,.5);\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
